import { apiFetch } from '~/api/client'
import type { BusinessContext, BusinessContextUpsertRequest } from '~/api/types'

/** 로그인 사용자의 활성 사업장 프로필을 조회한다. */
export function getActiveBusinessContext(): Promise<BusinessContext | null> {
    return apiFetch<BusinessContext | null>('/business-contexts/active')
}

/** 로그인 사용자의 활성 사업장 프로필을 생성하거나 갱신한다. */
export function upsertActiveBusinessContext(
    body: BusinessContextUpsertRequest
): Promise<BusinessContext> {
    return apiFetch<BusinessContext>('/business-contexts/active', {
        method: 'PUT',
        body,
    })
}
